<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">

                <transition name="fade">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title bold">Tell us about your business</h3>
                        </div>
                        <div class="card-body">

                            <div class="alert alert-warning2 text-justify" v-if="formLoan.bt_code">
                                <span v-if="formLoan.bt_code=='BT2020004'"><i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong> Must be the President/CEO of the Corporation</span>
                                <span v-if="formLoan.bt_code=='BT2020002'"><i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong> Must be the Managing Partner of the Partnership</span>
                                <span v-if="formLoan.bt_code=='BT2020001'"><i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong> Must be the sole proprietor/business owner</span>
                                <span v-if="formLoan.bt_code=='BT2020003'"><i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong> Must be the Chairman or President of the Cooperative</span>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Type of Business</label>
                                        <select class="form-control custom-select-sm" v-model="formLoan.bt_code" @change="selectedBusType" :class="{'is-invalid': $parent.submitting && $v.formLoan.bt_code.$error}">
                                            <option selected disabled :value='null'>- Select -</option>
                                            <option value="BT2020001">Sole Proprietorship</option>
                                            <option value="BT2020002">Partnership</option>
                                            <option value="BT2020004">Corporation</option>
                                            <option value="BT2020003">Cooperative</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div v-if="formLoan.bt_code">
                                <hr>
                                <div class="row" v-if="business_info.length >= 0">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Please select below (1) the business name if you are applying for an additional loan for the same business, (2) a new application for a different business or (3) you don't have a previous loan application with SB Corp.</label>
                                            <select class="form-control custom-select-sm" v-model="formLoan.loan_cat" @change="selectLoanCat" :class="{'is-invalid': $parent.submitting && $v.formLoan.loan_cat.$error}">
                                                <option selected disabled :value='null'>- Select -</option>
                                                <option value="1">Existing Business Name</option>
                                                <option value="2">Application for a different business</option>
                                                <option value="3">No previous loan application for any business</option>
                                            </select>
                                        </div>
                                        <div class="form-group" v-show="formLoan.loan_cat==1">
                                            <label>Select Business</label>
                                            <v-select label="business_name" class="text-uppercase" :options="business_info" :reduce="business_name => business_name.id" v-model="formLoan.bus_id" :clearable="false" @input="getBusID(formLoan.bus_id)" :class="{'vs-invalid': $parent.submitting && $v.formLoan.bus_id.$error}"></v-select>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="formLoan.loan_cat > 1 || formLoan.bus_id">
                                    <div>
                                        <hr>
                                        <p class="card-text text-justify bold">Business Details</p>

                                        <div class="alert alert-info2">
                                            <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>Please make sure that the business name you indicate matches the business name indicated in your business permit.
                                        </div>
                                        
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class="form-group">
                                                    <label v-if="formLoan.bt_code=='BT2020002'">Partnership Name</label>
                                                    <label v-if="formLoan.bt_code=='BT2020004'">Corporation Name</label>
                                                    <label v-if="formLoan.bt_code=='BT2020001'">Business Name</label>
                                                    <input type="text" :disabled="da_busname" class="form-control form-control-sm text-uppercase" @input="formLoan.business_name=$event.target.value.toUpperCase().trim()" v-model.trim="formLoan.business_name" :class="{'is-invalid': $parent.submitting && $v.formLoan.business_name.$error}" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label v-if="formLoan.bt_code=='BT2020002'">Partnership Date</label>
                                                    <label v-if="formLoan.bt_code=='BT2020004'">Incorporation Date</label>
                                                    <label v-if="formLoan.bt_code=='BT2020001'">Startup Date</label>
                                                    <date-range-picker @input="validatingDate(formLoan.start_date)" ref="start_date" v-if="start_date" class="form-control form-control-sm" :class="{'is-invalid': $parent.submitting && $v.formLoan.start_date.$error}" id="start_date" v-model="formLoan.start_date" :max-date="maxStartDate" :min-date="minStartDate" :start-date="startingDate" v-input-mask data-inputmask-alias="datetime" :data-inputmask-max="maxStartDate" :data-inputmask-min="minStartDate" data-inputmask-inputformat="mm/dd/yyyy" placeholder="mm/dd/yyyy"></date-range-picker>
                                                    <div v-show="$parent.submitting && $v.formLoan.start_date.$error" class="danger fs-13">Required at least 1 year</div>
                                                    <div v-show="$parent.submitting && validDate==false" class="danger fs-13">Invalid date format</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Business Address -->
                                    <div>
                                        <hr>
                                        <p class="card-text bold fs-17">Business Address</p>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Province</label>
                                                    <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="province" :class="{'vs-invalid': $parent.submitting && $v.formLoan.province_code.$error }" :options="provinces" :reduce="province => province.province_code" v-model="formLoan.province_code" :clearable="false" @input="getCity(formLoan.province_code), formLoan.city_code='',  formLoan.bcode=''"></v-select>
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>City/Municipality</label>
                                                    <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="city" :class="{'vs-invalid': $parent.submitting && $v.formLoan.city_code.$error }" :options="cities" :reduce="city => city.city_code" v-model="formLoan.city_code" :clearable="false" @input="getBrgy(formLoan.city_code), formLoan.bcode=''"></v-select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Barangay</label>
                                                    <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="bname" :class="{'vs-invalid': $parent.submitting && $v.formLoan.bcode.$error }" :options="brgys" :reduce="bname => bname.bcode" v-model="formLoan.bcode" :clearable="false"></v-select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>House No/Block & Lot/Building</label>
                                                    <input type="text" class="form-control form-control-sm text-uppercase" @input="formLoan.bldg=$event.target.value.toUpperCase().trim()" v-model.trim="formLoan.bldg" :class="{'is-invalid': $parent.submitting && $v.formLoan.bldg.$error}">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Street Name / Subdivision</label>
                                                    <input type="text" class="form-control form-control-sm text-uppercase" @input="formLoan.street_address=$event.target.value.toUpperCase().trim()" v-model.trim="formLoan.street_address" :class="{'is-invalid': $parent.submitting && $v.formLoan.street_address.$error}">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                            <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </transition>
</template>
<script>
    import moment from 'moment';
    import {
        createPopper
    } from '@popperjs/core';
    import {
        required,
        minLength
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formLoan'],
        data() {
            return {
                provinces: [],
                regions: [],
                cities: [],
                brgys: [],
                business_info: [],
                today: moment().format('MM/DD/YYYY'),
                minStartDate: moment('01/01/1900', 'MM/DD/YYYY').format('MM/DD/YYYY'),
                maxStartDate: moment().subtract(1, 'years').format('MM/DD/YYYY'),
                start_date: false,
                startingDate: moment().subtract(1, 'years').format('MM/DD/YYYY'),
                validDate: undefined,
            }
        },

        validations: {
            formLoan: {
                bt_code: {
                    required
                },
                loan_cat: {
                    required
                },
                bus_id: {
                    required
                },
                business_name: {
                    required
                },
                start_date: {
                    required
                },
                province_code: {
                    required
                },
                city_code: {
                    required
                },
                bcode: {
                    required
                },
                bldg: {
                    required
                },
                street_address: {
                    required
                },
            },
        },
        created() {
            this.getRegionProvince();

        },
        methods: {

            filterAreaCode() {
                let region = null;
                let prov_region_code = null;
                let area_code = null;
                if (this.formLoan.province_code && this.provinces.length != 0 && this.regions.length != 0) {
                    prov_region_code = this.provinces.find(item => item.province_code === this.formLoan.province_code).region_code;
                    area_code = this.regions.find(item => item.region_code === prov_region_code).area_code;
                }
                return area_code;
            },

            next() {
                this.$parent.submitting = false;
                this.$parent.submitting = true;

                this.formLoan.areacode = this.filterAreaCode();
                this.$v.formLoan.$touch();
                
                if (this.$v.formLoan.$invalid) {} else {    
                    
                    this.formLoan.s_start_date = moment(this.formLoan.start_date, "MM/DD/YYYY").format("YYYY-MM-DD");
                    let start_date = this.formLoan.s_start_date;
                    let years = moment().diff(start_date, 'years');
                    let months = moment().diff(start_date, 'months');
                    let countMonths = months % 12;
                    this.formLoan.total_years = years + '.' + countMonths;

                    this.$emit('next');
                }
            },


            getBusID(id) {
                this.start_date = false;
                let data = this.business_info;
                data = data.filter(function(item) {
                    return item.id == id;
                });

                if (data[0].id == 0) {
                    this.formLoan.business_name = null;
                    this.formLoan.total_years = null;
                    this.formLoan.start_date = null;
                    this.formLoan.s_start_date = null;
                    this.formLoan.bcode = null;
                    this.formLoan.city_code = null;
                    this.formLoan.province_code = null;
                    this.formLoan.bcode = null;
                    this.formLoan.bldg = null;
                    this.formLoan.street_address = null;
                    this.start_date = true;
                    this.startingDate = this.maxStartDate;
                    document.getElementById("start_date").value = "";
                } else {
                    this.getCertainBusInfo(data[0].id)
                    this.startingDate = this.maxStartDate;
                    this.start_date = true;
                }
            },


            getCertainBusInfo(id) {
                this.$parent.payloading = true;
                axios.get("/api/v2-get-certain-bus-info", {
                        params: {
                            id: id,
                        }
                    })
                    .then(res => {
                        if (res.data.length > 0) {
                            this.formLoan.business_name = res.data[0].business_name;
                            this.formLoan.total_years = res.data[0].total_years;
                            this.formLoan.start_date = res.data[0].start_date;
                            this.formLoan.bcode = res.data[0].bcode;
                            this.formLoan.city_code = res.data[0].city_code;
                            this.formLoan.province_code = res.data[0].province_code;
                            this.formLoan.bname = res.data[0].bname;
                            this.formLoan.city = res.data[0].city;
                            this.formLoan.province = res.data[0].province;
                            this.formLoan.bldg = res.data[0].bldg;
                            this.formLoan.street_address = res.data[0].street_address;

                            this.getCity(this.formLoan.province_code);
                            this.getBrgy(this.formLoan.city_code);

                            if (this.formLoan.start_date) {
                                this.formLoan.s_start_date = moment(this.formLoan.start_date, "MM/DD/YYYY").format("YYYY-MM-DD");
                                this.formLoan.start_date = moment(this.formLoan.start_date, "YYYY-MM-DD").format("MM/DD/YYYY");

                                this.start_date = true;
                                document.getElementById("start_date").value = this.formLoan.start_date;
                                this.startingDate = this.formLoan.start_date;
                            }
                            if (!this.formLoan.start_date) {
                                this.startingDate = this.maxStartDate;
                                this.start_date = true;
                            }
                        }
                        this.$parent.payloading = false;
                    })
                    .catch(error => {
                        this.$parent.payloading = false;
                        console.log(error);
                    });
            },

            validatingDate(e) {
                this.validDate = this.isDate(e)
            },
            isDate(val) {
                return moment(val, 'MM/DD/YYYY', true).isValid();
            },

            getBrgy(val) {
                this.$parent.payloading = true;
                axios.get('/api/v2-ref-brgy', {
                        params: {
                            city_code: val
                        }
                    })
                    .then(res => {
                        let data = res.data
                        this.brgys = data.brgys;
                        this.$parent.payloading = false;
                    })
                    .catch((err) => {
                        this.$parent.payloading = false;
                    })
            },
            getCity(val) {
                this.$parent.payloading = true;
                axios.get('/api/v2-ref-city', {
                        params: {
                            province_code: val
                        }
                    })
                    .then(res => {
                        let data = res.data
                        this.cities = data.cities;
                        this.$parent.payloading = false;
                    })
                    .catch(err => {
                        this.$parent.payloading = false;
                    })
            },
            selectLoanCat() {
                this.start_date = false;
                if (this.formLoan.loan_cat == 2 || this.formLoan.loan_cat == 3) {
                    setTimeout(() => {
                        this.formLoan.bus_id = 0;
                        this.formLoan.province_code = '';
                        this.formLoan.city_code = '';
                        this.formLoan.bcode = '';
                        this.formLoan.bldg = '';
                        this.formLoan.street_address = '';
                        this.formLoan.start_date = '';
                        this.formLoan.business_name = '';
                        this.startingDate = this.maxStartDate;
                        this.start_date = true;

                        this.cities = [];
                        this.brgys = [];
                    }, 333)
                } else {
                    this.getBusInfo();
                }
            },
            selectedBusType() {
                this.formLoan.loan_cat = null;
                this.formLoan.bus_id = null;
                this.getBusInfo();
            },
            getBusInfo() {
                if (this.formLoan.bt_code) {
                    this.$parent.payloading = true;
                    this.business_info = [];
                    axios.get("/api/v2-get-bus-info", {
                            params: {
                                borrower_id: this.formLoan.borrower_id,
                                bt_code: this.formLoan.bt_code,
                            }
                        })
                        .then(res => {
                            if (res.data.length > 0) {
                                this.business_info = res.data;
                                this.formLoan.loan_cat = 1;
                                this.start_date = true;

                            } else {
                                this.formLoan.bus_id = '';

                                this.formLoan.province_code = '';
                                this.formLoan.city_code = '';
                                this.formLoan.bcode = '';
                                this.formLoan.bldg = '';
                                this.formLoan.street_address = '';
                                this.formLoan.start_date = '';
                                this.formLoan.business_name = '';

                                this.startingDate = this.maxStartDate;
                                this.start_date = true;
                            }
                            this.$parent.payloading = false;
                        })
                        .catch(err => {
                            this.$parent.payloading = false;
                        });
                }
            },
            getRegionProvince() {
                this.$parent.payloading = true;
                axios.get('/api/v2-ref-region-province')
                    .then(res => {
                        this.$parent.payloading = false;
                        let data = res.data
                        this.provinces = data.provinces
                        this.regions = data.regions

                        if (this.formLoan.start_date) {
                            this.formLoan.start_date = moment(this.formLoan.start_date, "YYYY-MM-DD").format("MM/DD/YYYY");
                        }
                        this.getBusInfo();
                    })
                    .catch(err => {
                        this.$parent.payloading = false;
                    })
            },
            withPopper(dropdownList, component, {
                width,
                top,
                left
            }) {

                dropdownList.style.top = top;
                dropdownList.style.left = left;
                dropdownList.style.width = width;


                const popper = createPopper(component.$refs.toggle, dropdownList, {
                    placement: 'top',
                    modifiers: [{
                            name: 'offset',
                            options: {
                                offset: [0, -1]
                            }
                        },
                        {
                            name: 'toggleClass',
                            enabled: true,
                            phase: 'write',
                            fn({
                                state
                            }) {
                                component.$el.classList.toggle('drop-up', state.placement === 'top')
                            },
                        }
                    ]
                });
                return () => popper.destroy();
            },


        },
        computed: {
            da_busname() {
                if (this.formLoan.bus_id > 0) {
                    return true;
                }
                return false;
            },
        },
        mounted() {}
    }
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }
</style>